import React, { ReactNode } from 'react';

import AlertIcon from '../../../assets/icons/alert.svg?react';
import { Modal } from 'components/v2/Modal/Modal';
import { Heading } from 'components/v2/Typography/Heading';
import styled from 'styled-components';

export interface InstructionRow {
  name: string;
  body: ReactNode;
}

interface ModalProps {
  show: boolean;
  hide: () => void;
  title: string;
  alert?: string;
  rows: Array<InstructionRow>;
}

export const InstructionsModal = ({ alert, hide, rows, show, title }: ModalProps): JSX.Element => {
  return (
    <Modal title={title} open={show} onCancel={hide}>
      <Container>
        {alert && (
          <Alert>
            <AlertIcon />
            <span>{alert}</span>
          </Alert>
        )}
        {rows.map(row => (
          <InstructionGroup key={row.name}>
            <Heading tag="h3">{row.name}</Heading>
            <InstructionBody>{row.body}</InstructionBody>
          </InstructionGroup>
        ))}
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const InstructionGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const InstructionBody = styled.div`
  width: 100%;
  background-color: white;
  > p {
    margin-bottom: 16px;
  }
  > ul {
    margin-bottom: 16px;
    list-style-type: disc;
    padding-left: 20px;
  }
`;

const Alert = styled.div`
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  background-color: ${({ theme }) => theme.colors.semantic.pink};
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  width: 100%;
  margin-bottom: 16px;
`;
